// Tickets of a board in windows of their own: "Pop out" gives a ticket a window; "Add to the tabs window" puts it in the one window that holds several
// tickets as tabs. The page of such a window is the Boards page with ?window=tickets; these are the pure parts (the address, the list of tabs).

export const TABS_LIMIT = 12;

/** The address of a ticket window; `solo` is a window for one ticket only (nothing is added to it). */
export function ticketWindowUrl(base, boardId, cardId, { solo = false } = {}) {
  const u = new URL('boards.html', base);
  u.searchParams.set('window', 'tickets');
  if (solo) u.searchParams.set('solo', '1');
  u.hash = `#${boardId}/${cardId}`;
  return u.href;
}

/** Whether a page address (its search part) is a ticket window, and a one-ticket one. */
export function windowModeOf(search) {
  const p = new URLSearchParams(search);
  return p.get('window') === 'tickets' ? { solo: p.get('solo') === '1' } : null;
}

/** The tabs read back from storage: ticket numbers only, no repeats, not too many. */
export function cleanTabs(raw) {
  let list = raw;
  if (typeof raw === 'string') { try { list = JSON.parse(raw); } catch { list = []; } }
  return [...new Set((Array.isArray(list) ? list : []).map(Number).filter((n) => Number.isInteger(n) && n > 0))].slice(0, TABS_LIMIT);
}

/** A ticket added: it is the last tab (or already there) and the one shown. At the limit the oldest tab that is not the shown one goes. */
export function addTab(tabs, id) {
  const list = cleanTabs(tabs);
  if (list.includes(id)) return { tabs: list, active: id };
  if (list.length >= TABS_LIMIT) list.shift();
  return { tabs: [...list, id], active: id };
}

/** A tab closed: the one shown after it is the one that was next to it (null when none are left). */
export function closeTab(tabs, id, active) {
  const list = cleanTabs(tabs);
  const i = list.indexOf(id);
  if (i < 0) return { tabs: list, active };
  const rest = list.filter((t) => t !== id);
  if (active !== id) return { tabs: rest, active };
  return { tabs: rest, active: rest[Math.min(i, rest.length - 1)] ?? null };
}
